const state = {
  aboutus_banner: [],
};

export default state;
